export default "__VITE_ASSET__JuLXUEUs__"